import React, { useState } from 'react';

export default function ThinkyIOTSecurityGovernance({ onBack }) {
  const [users] = useState([
    { id: 1, name: 'Admin User', role: 'Administrator', lastLogin: '5 mins ago', status: 'Active' },
    { id: 2, name: 'Operator One', role: 'Operator', lastLogin: '30 mins ago', status: 'Active' },
    { id: 3, name: 'Guest User', role: 'Viewer', lastLogin: '2 hours ago', status: 'Inactive' },
  ]);

  const [auditLogs] = useState([
    { id: 1, user: 'Admin User', action: 'Added new device', time: '2025-12-18 09:15' },
    { id: 2, user: 'Operator One', action: 'Triggered RPC call', time: '2025-12-18 09:45' },
    { id: 3, user: 'Guest User', action: 'Viewed dashboard', time: '2025-12-18 10:00' },
  ]);

  return (
    <div className="min-h-screen bg-black text-white px-4 py-8">
      <button onClick={onBack} className="mb-6 px-4 py-2 bg-blue-600 rounded hover:bg-blue-500 w-24">&larr; Back</button>
      <h1 className="text-lg lg:text-xl font-bold mb-6">Security & Governance</h1>

      <section className="mb-8">
        <h2 className="text-lg font-semibold mb-3">User Management</h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {users.map(user => (
            <div key={user.id} className="bg-neutral-900 border border-neutral-800 rounded-2xl p-5 shadow-sm">
              <h3 className="text-lg font-semibold mb-2">{user.name}</h3>
              <p>Role: <span className="font-medium text-blue-400">{user.role}</span></p>
              <p>Status: <span className={`font-semibold ${user.status === 'Active' ? 'text-green-400' : 'text-gray-400'}`}>{user.status}</span></p>
              <p>Last Login: {user.lastLogin}</p>
            </div>
          ))}
        </div>
      </section>

      <section>
        <h2 className="text-lg font-semibold mb-3">Audit Logs</h2>
        <div className="bg-neutral-900 border border-neutral-800 rounded-2xl p-5 shadow-sm">
          <table className="w-full text-left text-sm">
            <thead>
              <tr>
                <th className="px-2 py-1">User</th>
                <th className="px-2 py-1">Action</th>
                <th className="px-2 py-1">Time</th>
              </tr>
            </thead>
            <tbody>
              {auditLogs.map(log => (
                <tr key={log.id} className="border-t border-neutral-800">
                  <td className="px-2 py-1">{log.user}</td>
                  <td className="px-2 py-1">{log.action}</td>
                  <td className="px-2 py-1">{log.time}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </section>
    </div>
  );
}
